import { render, staticRenderFns } from "./ChangePasswordComplete.vue?vue&type=template&id=ce9769c6&scoped=true&"
import script from "./ChangePasswordComplete.vue?vue&type=script&lang=ts&"
export * from "./ChangePasswordComplete.vue?vue&type=script&lang=ts&"
import style0 from "./ChangePasswordComplete.vue?vue&type=style&index=0&id=ce9769c6&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce9769c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
